
import { Users, TrendingUp, Clock, AlertTriangle } from "lucide-react";
import { formatCountWithArabicNumbers, formatPercentageWithArabicNumbers } from "@/utils/arabicNumbers";

interface LateAttendanceStatsCardProps {
  stats: {
    totalLateStudents: number;
    totalOnTimeStudents: number;
    totalLateInstances: number;
    latePercentage: number;
    attendanceRate: number;
    totalStudents: number;
  };
  studentsWithLateAlerts?: number; // إضافة عدد الطلاب الذين لديهم تنبيهات تأخر فعلية
}

export const LateAttendanceStatsCard = ({ stats, studentsWithLateAlerts = 0 }: LateAttendanceStatsCardProps) => {
  const onTimePercentage = stats.totalStudents > 0 ? 
    Math.round((stats.totalOnTimeStudents / stats.totalStudents) * 100) : 0;

  return (
    <div className="mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* إجمالي الطلاب */}
        <div className="flex items-center justify-between p-3 bg-gradient-to-r from-transparent via-brand-green/10 to-transparent rounded-xl border-l-4 border-brand-green border border-brand-green/20 shadow-sm hover:shadow-md transition-shadow backdrop-blur-sm">
          <div className="flex items-center gap-3">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-brand-green/10 rounded-full flex items-center justify-center">
                <Users className="h-4 w-4 text-brand-green" />
              </div>
            </div>
            <div className="text-xs font-medium text-brand-green">إجمالي الطلاب</div>
          </div>
          <div className="flex items-center gap-2">
            <div className="text-lg font-bold text-brand-green">{formatCountWithArabicNumbers(stats.totalStudents)}</div>
            <div className="text-xs text-brand-green">طالب</div>
          </div>
        </div>

        {/* معدل عدم التأخر */}
        <div className="flex items-center justify-between p-3 bg-gradient-to-r from-transparent via-brand-teal/10 to-transparent rounded-xl border-l-4 border-brand-teal border border-brand-teal/20 shadow-sm hover:shadow-md transition-shadow backdrop-blur-sm">
          <div className="flex items-center gap-3">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-brand-teal/10 rounded-full flex items-center justify-center">
                <TrendingUp className="h-4 w-4 text-brand-teal" />
              </div>
            </div>
            <div className="text-xs font-medium text-brand-teal">معدل عدم التأخر</div>
          </div>
          <div className="flex items-center gap-2">
            <div className="text-lg font-bold text-brand-teal">{formatPercentageWithArabicNumbers(onTimePercentage)}</div>
          </div>
        </div>

        {/* معدل التأخر */}
        <div className="flex items-center justify-between p-3 bg-gradient-to-r from-transparent via-brand-orange/10 to-transparent rounded-xl border-l-4 border-brand-orange border border-brand-orange/20 shadow-sm hover:shadow-md transition-shadow backdrop-blur-sm">
          <div className="flex items-center gap-3">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-brand-orange/10 rounded-full flex items-center justify-center">
                <Clock className="h-4 w-4 text-brand-orange" />
              </div>
            </div>
            <div className="text-xs font-medium text-brand-orange">معدل التأخر</div>
          </div>
          <div className="flex items-center gap-2">
            <div className="text-lg font-bold text-brand-orange">{formatPercentageWithArabicNumbers(stats.latePercentage)}</div>
          </div>
        </div>

        {/* تنبيهات التأخر */}
        <div className="flex items-center justify-between p-3 bg-gradient-to-r from-transparent via-brand-red/10 to-transparent rounded-xl border-l-4 border-brand-red border border-brand-red/20 shadow-sm hover:shadow-md transition-shadow backdrop-blur-sm">
          <div className="flex items-center gap-3">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-brand-red/10 rounded-full flex items-center justify-center">
                <AlertTriangle className="h-4 w-4 text-brand-red" />
              </div>
            </div>
            <div className="text-xs font-medium text-brand-red">تنبيهات التأخر</div>
          </div>
          <div className="flex items-center gap-2">
            <div className="text-lg font-bold text-brand-red">{formatCountWithArabicNumbers(studentsWithLateAlerts)}</div>
            <div className="text-xs text-brand-red">تنبيه</div>
          </div>
        </div>
      </div>
    </div>
  );
};
